<!-- 
Explanation for the "incomplete levy parameters" warning.
-->
<template>
  <v-alert 
    v-if="levyCollectionProvider.incompleteLevyParameters" :value="true" 
    :type="hasLevy ? 'info' : 'error'" 
    outline class="pa-3 ma-2"
  >
    <h3 class="heading mb-3 grey--text text--darken-3">{{ title }}</h3>
    <p class="grey--text text--darken-3">
      {{ levyCollectionProvider.incompleteLevyParametersExplanation | explanation }}
    </p>
    <p class="grey--text text--darken-3">
      <span v-if="hasLevy">
        The levy was able to be calculated because the levy calculations were adjusted
        such that the entire levy calculation was overridden.
      </span>
      <span v-else>
        <p>
          Before the system can calculate a levy, both the 
          <i>Upload financial strength parameters</i> 
          task and the 
          <i>Import parameters and calculate levies</i>
          task must be run. These can be found under <i>Workflow</i>.
        </p>
        <p>
          Alternatively, the <i>adjust levy calculations</i>
          function can be used to override the entire levy calculation for this provider.
        </p>
      </span>
    </p>
  </v-alert>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";

export default {
  mixins: [filterMixins],
  props: {
    levyCollectionProvider: {
      type: Object,
      required: true
    }
  },
  computed: {
    areIncomplete() {
      return this.levyCollectionProvider.incompleteLevyParameters;
    },
    hasLevy() {
      return this.levyCollectionProvider.levyCalculation.totalLevy != null;
    },
    title() {
      return this.hasLevy
        ? "Levy parameters are incomplete"
        : "The levy has not been calculated for this provider yet.";
    }
  }
};
</script>
